




















import { defineComponent } from "@vue/composition-api";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { PostFileData } from "@/types";
import BaseInputFile from "@/components/BaseInputFile";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";
import EditPostOverview from "../EditPostOverview";

export default defineComponent({
  name: "CreatePostView",
  components: { EditPostOverview, BaseInputFile, BasePage, PageTitle },
  props: {
    loading: { type: Boolean, required: true },
    postData: { type: Object as () => ContentSet | null },
    fileList: { type: Array as () => PostFileData[], required: true },
  },
  computed: {
    type(): string {
      if (!this.postData) return "";
      return this.postData.type;
    },
  },
});
